export const PERMISSIONS = {
  TRANGCHU: 'TRANGCHU',

  // Thanh tra
  QLKLKNTHANHTRA: 'QLKLKNTHANHTRA',
  QLKLKNTHANHTRA_DANHSACH: 'QLKLKNTHANHTRA_DANHSACH',
  QLKLKNTHANHTRA_CAPNHAT: 'QLKLKNTHANHTRA_CAPNHAT',
  THUCHIENKIENNGHI_THANHTRA_XEM: 'THUCHIENKIENNGHI_THANHTRA_XEM',
  THUCHIENKIENNGHI_THANHTRA_CAPNHAT: 'THUCHIENKIENNGHI_THANHTRA_CAPNHAT',
  THUCHIENKIENNGHI_THANHTRA_XOA: 'THUCHIENKIENNGHI_THANHTRA_XOA',
  THEODOIKIENNGHI_THANHTRA: 'THEODOIKIENNGHI_THANHTRA',

  // Kiểm toán
  QLKLKNKIEMTOAN: 'QLKLKNKIEMTOAN',
  QLKLKNKIEMTOAN_DANHSACH: 'QLKLKNKIEMTOAN_DANHSACH',
  QLKLKNKIEMTOAN_CAPNHAT: 'QLKLKNKIEMTOAN_CAPNHAT',
  THUCHIENKIENNGHI_KIEMTOAN_XEM: 'THUCHIENKIENNGHI_KIEMTOAN_XEM',
  THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT: 'THUCHIENKIENNGHI_KIEMTOAN_CAPNHAT',
  THUCHIENKIENNGHI_KIEMTOAN_XOA: 'THUCHIENKIENNGHI_KIEMTOAN_XOA',
  THEODOIKIENNGHI_KIEMTOAN: 'THEODOIKIENNGHI_KIEMTOAN',

  // Theo dõi tất cả
  THEODOIKETLUAN_XEMTATCA: 'THEODOIKETLUAN_XEMTATCA',
  KETLUANTHANHTRA_XEMTATCA: 'KETLUANTHANHTRA_XEMTATCA',
  KIENNGHITHANHTRA_XEMTATCA: 'KIENNGHITHANHTRA_XEMTATCA',
  KETLUANKIEMTOAN_XEMTATCA: 'KETLUANKIEMTOAN_XEMTATCA',
  KIENNGHIKIEMTOAN_XEMTATCA: 'KIENNGHIKIEMTOAN_XEMTATCA',

  // Danh mục
  DANHMUC: 'DANHMUC',
  DM_NHOMDOITUONG_DANHSACH: 'DM_NHOMDOITUONG_DANHSACH',
  DM_NHOMDOITUONG_CAPNHAT: 'DM_NHOMDOITUONG_CAPNHAT',
  DM_DOITUONGTHANHTRA_DANHSACH: 'DM_DOITUONGTHANHTRA_DANHSACH',
  DM_DOITUONGTHANHTRA_CAPNHAT: 'DM_DOITUONGTHANHTRA_CAPNHAT',
  DM_DOITUONGTHANHTRA_KHONGCANXACNHAN: 'DM_DOITUONGTHANHTRA_KHONGCANXACNHAN',
  DM_LOAIKETLUAN_DANHSACH: 'DM_LOAIKETLUAN_DANHSACH',
  DM_LOAIKETLUAN_CAPNHAT: 'DM_LOAIKETLUAN_CAPNHAT',
  DM_LINHVUCVIPHAM_DANHSACH: 'DM_LINHVUCVIPHAM_DANHSACH',
  DM_LINHVUCVIPHAM_CAPNHAT: 'DM_LINHVUCVIPHAM_CAPNHAT',
  DM_LOAIKIEMTOAN_DANHSACH: 'DM_LOAIKIEMTOAN_DANHSACH',
  DM_LOAIKIEMTOAN_CAPNHAT: 'DM_LOAIKIEMTOAN_CAPNHAT',
  DM_LOAICHIPHI_DANHSACH: 'DM_LOAICHIPHI_DANHSACH',
  DM_LOAICHIPHI_CAPNHAT: 'DM_LOAICHIPHI_CAPNHAT',
  DM_LOAINGUONVON_DANHSACH: 'DM_LOAINGUONVON_DANHSACH',
  DM_LOAINGUONVON_CAPNHAT: 'DM_LOAINGUONVON_CAPNHAT',
  DM_DUAN_DANHSACH: 'DM_DUAN_DANHSACH',
  DM_DUAN_CAPNHAT: 'DM_DUAN_CAPNHAT',
  DM_HINHTHUCXULY_DANHSACH: 'DM_HINHTHUCXULY_DANHSACH',
  DM_HINHTHUCXULY_CAPNHAT: 'DM_HINHTHUCXULY_CAPNHAT',
  DM_HINHTHUCKIENNGHI_DANHSACH: 'DM_HINHTHUCKIENNGHI_DANHSACH',
  DM_HINHTHUCKIENNGHI_CAPNHAT: 'DM_HINHTHUCKIENNGHI_CAPNHAT',
  SAOLUUBACKUP_XEM: 'SAOLUUBACKUP_XEM',
  SAOLUUBACKUP_CAPNHAT: 'SAOLUUBACKUP_CAPNHAT',
  HETHONG: 'HETHONG',

  // Phase 2: vụ án hình sự, file tập trung, phúc tra KTNN, danh mục mới
  VUAN: 'VUAN',
  VUAN_KHOITO_CAPNHAT: 'VUAN_KHOITO_CAPNHAT',
  VUAN_TRUYTO_CAPNHAT: 'VUAN_TRUYTO_CAPNHAT',
  VUAN_XETXU_CAPNHAT: 'VUAN_XETXU_CAPNHAT',
  VUAN_THIHANHAN_CAPNHAT: 'VUAN_THIHANHAN_CAPNHAT',
  VUAN_THEODOI_CAPNHAT: 'VUAN_THEODOI_CAPNHAT',
  VUAN_UYTHAC_CAPNHAT: 'VUAN_UYTHAC_CAPNHAT',
  VUAN_XEMTATCA: 'VUAN_XEMTATCA',
  VUAN_BAOCAO: 'VUAN_BAOCAO',
  DM_TOIPHAM_DANHSACH: 'DM_TOIPHAM_DANHSACH',
  DM_TOIPHAM_CAPNHAT: 'DM_TOIPHAM_CAPNHAT',
  DM_LOAITHUHOI_DANHSACH: 'DM_LOAITHUHOI_DANHSACH',
  DM_LOAITHUHOI_CAPNHAT: 'DM_LOAITHUHOI_CAPNHAT',
  DM_LOAITAISAN_DANHSACH: 'DM_LOAITAISAN_DANHSACH',
  DM_LOAITAISAN_CAPNHAT: 'DM_LOAITAISAN_CAPNHAT',
  DM_LOAIFILE_DANHSACH: 'DM_LOAIFILE_DANHSACH',
  DM_LOAIFILE_CAPNHAT: 'DM_LOAIFILE_CAPNHAT',
  QLFILE_TAPTRUNG: 'QLFILE_TAPTRUNG',
  KTNN_PHUCTRA: 'KTNN_PHUCTRA',

  // Báo cáo động
  BAOCAOTHONGKEDONG: 'BAOCAOTHONGKEDONG',
  BAOCAOTHONGKE: 'BAOCAOTHONGKE',

  //Bao cao thong ke moi
  BAOCAOTHONGKE_MOI: 'BCTKKLTHANHTRAKIEMTOAN'
}
